import { render, staticRenderFns } from "./tagModel.vue?vue&type=template&id=c3f180bc&lang=pug&"
import script from "./tagModel.vue?vue&type=script&lang=js&"
export * from "./tagModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports